import { useEffect } from "react";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { api, apiRoutes } from "../../../../api";
import { useMatchScreen } from "../../../../App";
import { DP, ITopic } from "../../../../common/types";
import Spinner from "../../../../components/Spinner";
import { createCustomStore } from "../../../../context/customStore";
import { useStateReducer } from "../../../../hooks/useStateReducer";
import { Topic } from "./components/Topic";

interface IState {
  isLoading: boolean;
  topics: ITopic[];
}

interface IStore {
  searchingTopics: string[];
}

export const {
  get: getTopicsStore,
  set: setTopicsStore,
  setOne: setTopicsStoreOne,
  useValue: useTopicsValue,
} = createCustomStore<IStore>({ searchingTopics: [] });

const Topics = ({ className }: DP) => {
  const [state, setState] = useStateReducer<IState>({
    isLoading: false,
    topics: [],
  });

  const screenMdMatch = useMatchScreen("md");

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        setState({ isLoading: true });
        const { data } = await api.get(apiRoutes.topics);
        setState({
          topics: data.topics,
          isLoading: false,
        });
      } catch (err) {}
    };

    fetchTopics();
  }, []);

  if (state.isLoading) return null;
  if (state.topics.length === 0) return null;

  return (
    <Wrapper className={className}>
      {screenMdMatch && <h3>Popular topics</h3>}
      <List>
        {state.topics.map((el) => (
          <Topic topic={el} />
        ))}
      </List>
    </Wrapper>
  );
};

const Wrapper = styled.div(() => [
  tw`flex flex-col flex-wrap gap-1`,
	tw`md:(pl-[var(--gap-x-global)])`,
  css`
    --text-clr: rgba(0, 0, 0, 0.4);

    font-size: 1rem;

    h3 {
      font-size: 0.45rem;
      font-weight: bold;
      color: var(--text-clr);
    }
  `,
]);

const List = styled.ul(() => [
  tw`flex flex-wrap gap-1`,
  tw`overflow-visible md:(w-full overflow-x-auto)`,
]);



export default styled(Topics)``;
